export enum PaymentEntityType {
  Order = 'order',
  Restaurant = 'restaurant',
  Customer = 'customer',
  ClubMember = 'club_member',
}
